function load(fn) {		
	if(window.YT) {
		fn()
	}
	else {
      window.onYouTubeIframeAPIReady = fn
		const tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		const firstScriptTag = 	document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
}

export default load

